//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getPlatformName } from '@/lib/platforms'

export default {
  name: 'CreatePostAccountsPicker',
  props: {
    selectedSocialAccounts: {
      type: Array,
      default: () => []
    },
    prioritizePlatform: {
      type: String,
      default: ''
    },
    triggerLabel: {
      type: String,
      default: 'Select Accounts'
    },
    triggerType: {
      type: String,
      default: 'is-info'
    },
    triggerIconPack: {
      type: String,
      default: 'far'
    },
    triggerClass: {
      type: String,
      default: ''
    },
    displayImportDropdown: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      search: '',
      displayModal: false,
      stagedAccounts: [],
      maxDropdownAccounts: 6
    }
  },
  methods: {
    getPlatformName,
    open() {
      this.displayAccountPicker()
    },
    displayAccountPicker() {
      if (this.shouldDisplayDropdown) {
        this.$refs.dropdown.toggle()
      } else {
        this.displayModal = true
        this.$nextTick(() => {
          if (this.$refs.searchField) {
            this.$refs.searchField.focus()
          }
        })
      }
    },
    hideAccountPicker() {
      if (this.shouldDisplayDropdown) {
        this.$refs.dropdown.toggle()
      } else {
        this.displayModal = false
        this.search = ''
        this.stagedAccounts = []
      }
    },
    toggleAccount(account) {
      if (this.isStaged(account)) {
        this.stagedAccounts = this.stagedAccounts.filter(
          (selectedAccount) => selectedAccount.id !== account.id
        )
      } else {
        this.stagedAccounts.push(account)
      }
    },
    isStaged(account) {
      return this.stagedAccounts.some(
        (selectedAccount) => selectedAccount.id === account.id
      )
    },
    isSelected(account) {
      return this.selectedSocialAccounts.some(
        (selectedAccount) => selectedAccount.id === account.id
      )
    },
    handleSelectAccounts() {
      this.$emit('accounts-selected', this.stagedAccounts)
      this.stagedAccounts = []
      this.hideAccountPicker()
    },
    accountsRowClass(row, index) {
      let rowClass = 'accounts-table-row'

      if (this.lastPlatformIndexes.includes(index)) {
        rowClass += ' is-last-platform'
      }
      return rowClass
    },
    addClientAccounts(client) {
      const newStagedAccounts = [
        ...this.socialAccounts.filter(
          (account) =>
            client.socialAccounts.some((ca) => ca.id === account.id) &&
            !this.stagedAccounts.some((sa) => sa.id === account.id)
        )
      ]
      this.stagedAccounts = newStagedAccounts
      this.handleSelectAccounts()
    }
  },
  computed: {
    shouldDisplayDropdown() {
      return this.socialAccounts.length <= this.maxDropdownAccounts
    },
    socialAccounts() {
      return this.$store.state.profile.socialAccounts.filter(
        (account) => account.platform !== 'REDDIT'
      )
    },
    filteredSocialAccounts() {
      return this.socialAccounts.filter(
        (account) =>
          account.username.toLowerCase().includes(this.search.toLowerCase()) ||
          account.formattedUsername
            .toLowerCase()
            .includes(this.search.toLowerCase()) ||
          account.platform.toLowerCase().includes(this.search.toLowerCase())
      )
    },
    selectableAccounts() {
      let accounts = this.socialAccounts.filter(
        (account) => !this.isSelected(account)
      )

      if (this.prioritizePlatform) {
        accounts = accounts.sort((a, b) => {
          if (
            a.platform.toLowerCase() === this.prioritizePlatform.toLowerCase()
          ) {
            return -1
          } else if (
            b.platform.toLowerCase() === this.prioritizePlatform.toLowerCase()
          ) {
            return 1
          } else {
            return 0
          }
        })
      }

      return accounts
    },
    lastPlatformIndexes() {
      const lastPlatformIndexes = []
      this.filteredSocialAccounts.forEach((account, index) => {
        if (index === this.filteredSocialAccounts.length - 1) {
          lastPlatformIndexes.push(index)
        } else if (
          account.platform !== this.filteredSocialAccounts[index + 1].platform
        ) {
          lastPlatformIndexes.push(index)
        }
      })
      return lastPlatformIndexes
    }
  }
}
